import axios from 'axios'
import { MethodType } from '../constants/MethodType'
import { CLIENT_ID, CLIENT_SECRET, REDIRECT_URI } from '../constants/GoogleAuth'

const api = require('./api')

export const login = params => api.request(1, '/session', MethodType.POST, params, false, {})

export const logout = () => api.request(1, '/session', MethodType.DELETE)

export const adminLogin = params => api.request(1, '/adminLogin', MethodType.POST, params, false, {})

export const checkUserToken = params => api.request(1, '/checkUserToken', MethodType.GET, params)

export const adminData = params => api.request(1, '/adminData', MethodType.GET, params)

export const fetchFunctions = params => api.request(1, '/functions', MethodType.GET, params)

export const forgetPassword = (role, params) => api.request(1, `/forgetPassword/${role}`, MethodType.POST, params, { 'x-api-token': 'FlBZux2!vZBaC@t' })

export const modifyPassword = params => api.request(1, '/modifyPassword', MethodType.PATCH, params, { 'x-api-token': 'FlBZux2!vZBaC@t' })

export const resetPassword = params => api.request(1, '/resetPassword', MethodType.POST, params, { 'x-api-token': 'FlBZux2!vZBaC@t' }, true)

export const getGoogleRefreshToken = async code => {
  try {
    const result = await axios({
      url: 'https://oauth2.googleapis.com/token',
      method: MethodType.POST,
      params: {
        code,
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        redirect_uri: REDIRECT_URI,
        grant_type: 'authorization_code'
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    return result
  } catch (error) { return error?.response }
}

export const fetchGenbiProfileName = (brandId, params) => api.request(1, `/genBi/profileName/${brandId}`, MethodType.GET, params)

export const updateBrandSelection = params => api.request(1, '/session/brand', MethodType.PATCH, params)
